interface RootScriptsProps {
  env: Record<string, string | undefined>
  webVitalsMetricsUrl: string
  gtmId?: string
}

export function RootScripts({
  env,
  webVitalsMetricsUrl,
  gtmId
}: RootScriptsProps) {
  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `window.ENV = ${JSON.stringify(env)}`
        }}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
            function processWebVitals(metrics) {
              navigator.sendBeacon('${webVitalsMetricsUrl}', JSON.stringify({ ...metrics, additionalData: { shop: shopify.config.shop, pageUrl: window.location.pathname } }));
            }
            shopify.webVitals.onReport(processWebVitals);
          `
        }}
      />
      {/* https://github.com/remix-run/remix/issues/4822#issuecomment-2015219081 */}
      <script
        dangerouslySetInnerHTML={{
          __html: `
              const observerConfig = {
                childList: true,
                subtree: true,
                attributes: true,
                attributeOldValue: true,
                characterData: true,
                characterDataOldValue: true,
              };
              window.hydration_observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                  switch (mutation.type) {
                    case 'childList': {
                      window.hydration_observer.disconnect();
                      mutation.addedNodes.forEach((node) => {
                        try {
                          mutation.target.removeChild(node);
                        } catch (e) {
                          console.error(e);
                        }
                      });
                      window.hydration_observer.observe(document, observerConfig);
                      break;
                    }
                    case 'attributes': {
                      mutation.target.removeAttribute(mutation.attributeName);
                      break;
                    }
                  }
                });
                
              });
              window.addEventListener('DOMContentLoaded', () => {
                window.hydration_observer.observe(document, observerConfig);
              });
            `
        }}
      />
      {gtmId && (
        <noscript>
          <iframe
            title="GTM-NS"
            src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
            height="0"
            width="0"
            style={{ display: 'none', visibility: 'hidden' }}
          />
        </noscript>
      )}
    </>
  )
}
